import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

export default function initChoiceDropdown(select) {
    const instance = new Choices(select, {
        searchEnabled: false,
        itemSelectText: '',
        shouldSort: false
    });

    const selectedValue = select.value;
    const dropdownItems = select.closest('.choices').querySelectorAll('[data-choice]');

    dropdownItems.forEach(el => {
        const isSelected = el.getAttribute('data-value') === selectedValue;
        el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        el.classList.toggle('is-highlighted', isSelected);
    });

    return instance;
}